import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import './index.scss';
import reportWebVitals from './reportWebVitals';
import './i18n/i18n';
import App from './App';
import {LicenseInfo} from "@mui/x-date-pickers-pro";

LicenseInfo.setLicenseKey("4273236824c88678a8799c0025e0ce97Tz0xMjQxODMsRT0xODAxODcxOTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=");

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
